module.exports = __webpack_public_path__ + "img/help-circle.b9af37e0.svg";